'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    token: state.auth.token,
    loading: state.auth.loading,
    error: state.auth.error
  };
}, { login: _auth.login }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (event) {
      event.preventDefault();
      _this.props.login(_this.refs.email.value, _this.refs.password.value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          token = _props.token,
          error = _props.error,
          loading = _props.loading;

      var styles = require('./Login.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        _react2.default.createElement(
          'h1',
          null,
          'Connexion'
        ),
        !token && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { onSubmit: this.handleSubmit },
            error && _react2.default.createElement(
              'div',
              { className: styles.error },
              error.errorMessage
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement('input', { type: 'text', ref: 'email', placeholder: 'E-mail', className: 'form-control' }),
              _react2.default.createElement('input', { type: 'password', ref: 'password', placeholder: 'Mot de passe', className: 'form-control' })
            ),
            _react2.default.createElement(
              _reactLadda2.default,
              { className: styles.button,
                'data-style': 'slide-down',
                loading: loading, onClick: this.handleSubmit },
              _react2.default.createElement(
                'span',
                null,
                'Se connecter'
              )
            )
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  token: _react.PropTypes.string,
  login: _react.PropTypes.func,
  error: _react.PropTypes.object,
  loading: _react.PropTypes.bool.isRequired
}, _temp2)) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1173
// module chunks = 0